module.exports = __webpack_public_path__ + "static/media/graficos.c527b163.png";